/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const processingProgressDtoSchema = z.object({
  stage: z.optional(z.string()),
  step: z.optional(z.int()),
  totalSteps: z.optional(z.int()),
  percent: z.optional(z.int()),
  isTerminal: z.optional(z.boolean()),
  outcome: z.string().nullish(),
});
